import { Button } from "@Light/components/page/Button";
import { PageBody } from "@Light/components/page/PageBody";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { Input } from "@Light/components/system/Input";
import { useNavigate } from "@Light/utils/context";
import { useForm } from "react-hook-form";

export type EnterZipProps = {};

export const EnterZip: React.FC<EnterZipProps> = ({}) => {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const onSubmit = handleSubmit(({ zip_code }) => {
    navigate(`/shop/by-zip?${new URLSearchParams({ zip_code })}`);
  });
  return (
    <form onSubmit={onSubmit}>
      <PageBody
        footerAfterContent={true}
        title="Please enter your zip code"
        subtitle="Enter your zip code below to discover available plans in your area"
        footer={
          <ButtonFooter>
            <Button
              type="submit"
              className="bg-blue-600 hover:bg-blue-300 w-full"
            >
              Search
            </Button>
          </ButtonFooter>
        }
      >
        <Input
          type="number"
          placeholder="Zip code"
          {...register("zip_code", { required: true })}
        />
      </PageBody>
    </form>
  );
};
